export default window.google.maps;
